// stores/board.js
import { defineStore } from 'pinia'

export const useBoardStore = defineStore('board', {
  state: () => ({
    boardConfig: {
      action: "",
      detail: "",
      user_type: "",
      existing_tools: "",
    }
  }),
  actions: {
    setBoardConfig(config) {
      this.boardConfig = config
    },
    resetBoardConfig() {
      this.boardConfig = {
        action: "",
        detail: "",
        user_type: "",
        existing_tools: "",
      }
    }
  }
})